// Branded loading state: avatar + copy + pulsing dots
// Replaces generic spinners across the app

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translationHelpers';

export type LoadingContext = 'practice' | 'exam' | 'coach' | 'weakAreas' | 'dashboard' | 'general';

const COACH_AVATAR_PATH = '/images/mascot.png?v=3';

interface BrandedLoadingProps {
  context: LoadingContext;
}

export function BrandedLoading({ context }: BrandedLoadingProps) {
  const { t_nested } = useLanguage();
  const key = `loading.${context}`;
  const fallbacks: Record<LoadingContext, string> = {
    practice: 'Preparing your questions...',
    exam: 'Building your personal exam...',
    coach: 'Your coach is thinking...',
    weakAreas: 'Checking your weak spots...',
    dashboard: 'Getting things ready...',
    general: 'Just a moment...',
  };
  const copy = getTranslation(t_nested, key, fallbacks[context]);

  return (
    <div
      className="loading-container"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="loading-avatar">
        <img
          src={COACH_AVATAR_PATH}
          alt=""
          className="loading-avatar-img"
        />
      </div>
      <p className="loading-copy">{copy}</p>
      <div className="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}
